var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.765625 4.98142V15.8882C0.765625 16.4365 0.983292 16.962 1.3711 17.3491C1.75821 17.737 2.28378 17.9546 2.83208 17.9546H10.4091C10.7893 17.9546 11.0979 17.646 11.0979 17.2658C11.0979 16.8856 10.7893 16.577 10.4091 16.577C10.4091 16.577 5.34351 16.577 2.83208 16.577C2.64954 16.577 2.47389 16.5047 2.34508 16.3752C2.21559 16.2464 2.14326 16.0707 2.14326 15.8882V4.98142C2.14326 4.60119 1.83467 4.2926 1.45444 4.2926C1.07422 4.2926 0.765625 4.60119 0.765625 4.98142Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2343 4.74999C15.2343 4.201 15.0159 3.67475 14.6281 3.28694L11.9865 0.649458C11.5994 0.262342 11.0738 0.0453644 10.5262 0.0453644C9.45163 0.0453644 7.09725 0.0453644 5.58599 0.0453644C5.03769 0.0453644 4.51212 0.263031 4.125 0.650835C3.7372 1.03795 3.51953 1.56352 3.51953 2.11182V13.1329C3.51953 13.6812 3.7372 14.2068 4.125 14.5939C4.51212 14.9817 5.03769 15.1994 5.58599 15.1994H13.1637C14.3044 15.1994 15.2294 14.275 15.2301 13.1336L15.2343 4.74999ZM13.8566 4.7493L13.8525 13.1329C13.8525 13.5138 13.5439 13.8217 13.1637 13.8217H5.58599C5.40345 13.8217 5.2278 13.7494 5.09899 13.6199C4.96949 13.4911 4.89717 13.3154 4.89717 13.1329V2.11182C4.89717 1.92928 4.96949 1.75363 5.09899 1.62482C5.2278 1.49533 5.40345 1.423 5.58599 1.423H10.5262C10.7087 1.423 10.8837 1.49533 11.0132 1.62414L13.6541 4.26162C13.7836 4.39112 13.8566 4.56677 13.8566 4.7493Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyFile);
export default __webpack_public_path__ + "static/media/copy-file.9ec68f7f2d20eb4e2f44fcd770348e1e.svg";
export { ForwardRef as ReactComponent };